var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"base-card shadow mt-4"},[_c('CardFieldRow',{staticClass:"ma-0 pl-1 py-2",attrs:{"label":"Сотрудник, отправивший  работу на проверку","value":_vm.creatorName,"disabled":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }